module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/meditating@3x_3fb626.jpg";